import * as types from '../mutation-types';
import { Module } from 'vuex';
import api from '../../api/modules/data-import';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface State {}

const initialState: State = {};

const dataImportModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {},
  actions: {
    async getStudentImports(_, params): Promise<PaginatedResponse<any>> {
      const data = await api.getStudentImports(params.page);
      return data;
    },
    async getMediaImports(_, params): Promise<PaginatedResponse<any>> {
      const data = await api.getMediaImports(params.page);
      return data;
    },
    async getClassCardImports(_, params): Promise<PaginatedResponse<any>> {
      const data = await api.getClassCardImports(params.page);
      return data;
    },
    async getPurchasesImports(_, params): Promise<PaginatedResponse<any>> {
      const data = await api.getPurchasesImports(params.page);
      return data;
    },
    async getSubscriptionsImports(_, params): Promise<PaginatedResponse<any>> {
      const data = await api.getSubscriptionsImports(params.page);
      return data;
    },
    async importsStudentsCSV(_, file): Promise<any> {
      const data = await api.importsStudentsCSV(file);
      return data;
    },
    async importsMediaCSV(_, file): Promise<any> {
      const data = await api.importsMediaCSV(file);
      return data;
    },
    async importsClassCardsCSV(_, file): Promise<any> {
      const data = await api.importsClassCardsCSV(file);
      return data;
    },
    async importsPurchasesCSV(_, file): Promise<any> {
      const data = await api.importsPurchasesCSV(file);
      return data;
    },
    async importsSubscriptionsCSV(_, file): Promise<any> {
      const data = await api.importsSubscriptionsCSV(file);
      return data;
    },
  },
  mutations: {},
};
export default dataImportModule;
